/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import styled from '@emotion/styled';
import { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import { StyledRetryLink } from './banner.style';
/**
 * Enum for Banner Style (GLOBAL is deprecated)
 * @enum {string}
 */
export var BannerStyle;
(function (BannerStyle) {
    BannerStyle["ALERT"] = "alert";
    BannerStyle["GLOBAL"] = "global";
    BannerStyle["HIALERT"] = "hi-alert";
    BannerStyle["CONFIRM"] = "confirm";
    BannerStyle["INSTRUCT"] = "instruct";
    BannerStyle["ACKNOWLEDGE"] = "acknowledge";
})(BannerStyle || (BannerStyle = {}));
const StyledDiv = styled('div')((props) => `
	white-space: ${props.shouldWrap ? 'normal' : 'nowrap'} !important;
	flex-wrap: ${props.shouldWrap ? 'wrap' : 'nowrap'} !important;
`);
export const Banner = props => {
    const [isHidden, setIsHidden] = useState(false);
    const shouldWrap = props.isFindNearByPreviewBanner ? true : props.shouldWrapContent;
    const handleClose = (event) => {
        setIsHidden(true);
        event.stopPropagation();
        props.handleBannerClosed && props.handleBannerClosed();
    };
    const onRetryLinkClick = (event) => {
        event.stopPropagation();
        props.onRetryLinkClick && props.onRetryLinkClick();
    };
    if (isHidden) {
        return null;
    }
    const closeIcon = props.shouldShowCloseIcon ? (jsx("div", { className: "mi-icat-action", style: props.bannerCloseIconStyle },
        jsx("div", { className: "mi-icon-action-close mi-icon-close", onClick: handleClose }))) : null;
    const retryLink = props.shouldShowRetryLink && (jsx("div", { className: "mi-icat-action" },
        jsx(StyledRetryLink, { "data-test": "retry-link", onClick: onRetryLinkClick }, props.retryText)));
    const bannerClass = `mi-uam-banner--${props.bannerStyle}`;
    return (jsx(Grid, { id: props.id, container: true, alignItems: props.shouldTopAlignItems ? 'flex-start' : 'center', wrap: "nowrap", className: bannerClass, css: css `
				flex-shrink: 0;
			` },
        jsx("div", { className: "mi-icat-icon" },
            jsx("div", { className: props.iconName })),
        jsx(StyledDiv, { className: "mi-icat-content", shouldWrap: shouldWrap }, props.children),
        retryLink,
        closeIcon));
};
Banner.defaultProps = {
    id: '',
    shouldWrapContent: false,
    shouldShowCloseIcon: false,
    shouldShowRetryLink: false,
    retryText: 'Retry',
    shouldTopAlignItems: false
};
//# sourceMappingURL=Banner.js.map